import { createContext } from "react";
import { AppPageLayout } from "./AppPageLayout";

export const AppPageLayoutContext = createContext<AppPageLayout | undefined>(
  undefined
);
